// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const weighStation = defineModel({
  id: "weigh-station",
  batchId: "future",
  name: "Weigh station",
  tags: ["building","weigh","station","low-poly","age-of-mcp","future"],
  summary: "A public balance for weighing goods fairly in trade and tax.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.6, 0.14, 1.6), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.6, 0.14, 1.6), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.6, 0.06), color: "#6e4f2e", position: [-0.55, 0.44, -0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 0.6, 0.06), color: "#6e4f2e", position: [0.55, 0.44, -0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 0.6, 0.06), color: "#6e4f2e", position: [-0.55, 0.44, 0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 0.6, 0.06), color: "#6e4f2e", position: [0.55, 0.44, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.65, 0.5, -0.65] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.65, 0.5, -0.65] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.65, 0.5, 0.65] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.65, 0.5, 0.65] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.6, 0.14, 1.6), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [-0.55, 0.665, -0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [0.55, 0.665, -0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [-0.55, 0.665, 0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [0.55, 0.665, 0.55] },
      { geometry: new THREE.BoxGeometry(0.07, 0.6, 0.07), color: "#7a5a36", position: [0, 0.44, 0] },
      { geometry: new THREE.BoxGeometry(0.9, 0.04, 0.04), color: "#7a5a36", position: [0, 0.79, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.06, 0.07), color: "#55504a", position: [0, 0.82, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.008, 0.2, 4), color: "#b9a574", position: [-0.4, 0.69, 0] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.1, 0.04, 10), color: "#8a8278", position: [-0.4, 0.58, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.008, 0.2, 4), color: "#b9a574", position: [0.4, 0.69, 0] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.1, 0.04, 10), color: "#8a8278", position: [0.4, 0.58, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.65, 0.7, -0.65] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.65, 0.7, -0.65] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.65, 0.7, 0.65] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.65, 0.7, 0.65] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.6, 0.14, 1.6), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [-0.55, 0.665, -0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [0.55, 0.665, -0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [-0.55, 0.665, 0.55] },
      { geometry: new THREE.BoxGeometry(0.06, 1.05, 0.06), color: "#6e4f2e", position: [0.55, 0.665, 0.55] },
      { geometry: new THREE.BoxGeometry(0.07, 0.6, 0.07), color: "#7a5a36", position: [0, 0.44, 0] },
      { geometry: new THREE.BoxGeometry(0.9, 0.04, 0.04), color: "#7a5a36", position: [0, 0.79, 0] },
      { geometry: new THREE.BoxGeometry(0.07, 0.06, 0.07), color: "#55504a", position: [0, 0.82, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.008, 0.2, 4), color: "#b9a574", position: [-0.4, 0.69, 0] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.1, 0.04, 10), color: "#8a8278", position: [-0.4, 0.58, 0] },
      { geometry: new THREE.CylinderGeometry(0.008, 0.008, 0.2, 4), color: "#b9a574", position: [0.4, 0.69, 0] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.1, 0.04, 10), color: "#8a8278", position: [0.4, 0.58, 0] },
      { geometry: new THREE.ConeGeometry(1, 0.34, 4), color: "#5a6e52", position: [0, 1.36, 0], rotation: [0, 0.785398, 0], scale: [0.989949, 1, 0.989949] },
    ] },
  ],
  animations: [],
});
